import { useState } from "react"
import { Box, Chip, TextField, Typography } from "@mui/material"
import Icn from "../UI/SharieIcn/SharieIcn"
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff"
import FilterAltIcon from "@mui/icons-material/FilterAlt"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"

const FilterStripe = (props) => {
  const [selectedFilter, setSelectedFilter] = useState("")
  const [skillText, setSkillText] = useState("")
  const [userText, setUserText] = useState("")
  const [locationText, setLocationText] = useState("")
  const filter_not_selected = selectedFilter === "" || selectedFilter === null
  const t = useTranslationSharie()

  const handleFilter = (filterType) => {
    if (selectedFilter === filterType) setSelectedFilter(null)
    else setSelectedFilter(filterType)
  }

  const handleKeyDown = (e, filterType) => {
    if (e.key === "Enter") {
      const filterValue =
        filterType === "skillName" ? skillText : filterType === "userName" ? userText : locationText

      if (props.setSelectedFilter) {
        props.setSelectedFilter({ type: filterType, value: filterValue })
      }
    }
  }
  const handleFilterClick = () => {
    const filterValue =
      selectedFilter === "skillName"
        ? skillText
        : selectedFilter === "userName"
        ? userText
        : locationText

    if (props.setSelectedFilter) {
      props.setSelectedFilter({ type: selectedFilter, value: filterValue })
    }
  }
  const clearStates = () => {
    setSelectedFilter("")
    props.setSelectedFilter(null)
    setSkillText("")
    setUserText("")
    setLocationText("")
  }

  return (
    <T>
      <Box
        display='flex'
        alignItems='center'
        p={2}
        bgcolor='background.paper'
        color='primary.main'
        boxShadow={2}
        borderRadius={"0.8rem"}
      >
        <Typography variant='h6' sx={{ marginRight: 2, marginLeft: 2 }}>
          {t("Filter")}
        </Typography>

        <Box display='flex' gap={1} alignItems='center'>
          {/* Reduced gap */}
          <Chip
            label={t("Skill")}
            color='secondary'
            onClick={() => handleFilter("skillName")}
            clickable
            disabled={selectedFilter !== "skillName" && !filter_not_selected}
          />
          {selectedFilter === "skillName" && (
            <TextField
              placeholder={t("Enter skill name")}
              onChange={(e) => setSkillText(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, "skillName")}
              autoFocus
            />
          )}
          <Chip
            label={t("User")}
            color='secondary'
            onClick={() => handleFilter("userName")}
            clickable
            disabled={selectedFilter !== "userName" && !filter_not_selected}
          />
          {selectedFilter === "userName" && (
            <TextField
              placeholder={t("Enter user name")}
              onChange={(e) => setUserText(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, "userName")}
              autoFocus
            />
          )}
          <Chip
            label={t("Location")}
            color='secondary'
            onClick={() => handleFilter("location")}
            clickable
            disabled={selectedFilter !== "location" && !filter_not_selected}
          />
          {selectedFilter === "location" && (
            <TextField
              placeholder={t("Enter location")}
              onChange={(e) => setLocationText(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, "location")}
              autoFocus
            />
          )}
          <Icn
            tooltip={"Filter"}
            color={"inherit"}
            onClick={handleFilterClick}
            icon={<FilterAltIcon />}
            disabled={filter_not_selected}
          />
          <Icn
            tooltip={"Reset Filter"}
            color={"inherit"}
            onClick={clearStates}
            icon={<FilterAltOffIcon />}
            disabled={filter_not_selected}
          />
        </Box>
      </Box>
    </T>
  )
}

export default FilterStripe
